import propertiesSpec from './propertiesSpec';

export default (function () {
  return {};
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-box/es/BoxTheme.js
// module id = 1020
// module chunks = 0